import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useLanguage } from "../hooks/useLanguage";
import PORTFOLIO_LOGO from "../images/portfolio-logo.webp";
import "./navbar-style.scss";

export const Navbar = () => {
  const { translations: t, language, toggleLanguage } = useLanguage();
  const HEADER = t.header;
  const location = useLocation();
  const [active, setActive] = useState("/");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      setScrolled(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const path = location.pathname;
    // Lógica simplificada basada en ruta para activar el item
    // Ya que el texto del header cambia, es mejor confiar en la ruta
    let activeContent = "";
    if (path === "/") activeContent = HEADER[0].content; // Home
    else if (path === "/about") activeContent = HEADER[1].content; // About
    else if (path === "/projects") activeContent = HEADER[2].content; // Projects
    else if (path === "/experience") activeContent = HEADER[3].content; // Experience
    else if (path === "/contact") activeContent = HEADER[4].content; // Contact
    
    if (activeContent) setActive(activeContent);
  }, [location.pathname, HEADER, language]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (!isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  };

  const closeMenu = (itemName: string) => {
    setIsMenuOpen(false);
    document.body.style.overflow = "unset";
    setActive(itemName);
  };

  const getNavLink = (index: number) => {
    switch(index) {
      case 0: return "/";
      case 1: return "/about";
      case 2: return "/projects";
      case 3: return "/experience";
      case 4: return "/contact";
      default: return "/";
    }
  };

  return (
    <nav className={`navbar_container ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar_content">
        <Link to="/" className="logo_link" onClick={() => closeMenu(HEADER[0].content)}>
          <img src={PORTFOLIO_LOGO} alt="Portfolio Logo" className="logo" />
        </Link>

        {/* Botón de idioma visible solo en responsive (entre logo y hamburguesa) */}
        <div className="mobile_lang_switch">
          <button onClick={toggleLanguage} className="lang_btn">
            {language === 'es' ? 'ES' : 'EN'}
          </button>
        </div>

        <button 
          className={`menu_toggle ${isMenuOpen ? "is-active" : ""}`} 
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        <ul className={`nav_menu ${isMenuOpen ? "active" : ""}`}>
          {HEADER.map((item, index) => (
            <li className="nav_item" key={index}>
              <Link
                to={getNavLink(index)}
                className={`nav_link ${active === item.content ? "active" : ""}`}
                onClick={() => closeMenu(item.content)}
              >
                {item.content}
              </Link>
            </li>
          ))}
          <li className="nav_item language_switch desktop_only">
            <button onClick={toggleLanguage} className="lang_btn">
              {language === 'es' ? 'ES' : 'EN'}
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};
